/* Secțiunea amphr-password — comutatorul panoului de staff.
   Mutat din `<script>`-ul inline al secțiunii: JS-ul trăiește în assets/*.js.

   Comută CLASA `.is-open` a tiparului `.collapse` (assets/amphr-base.css), nu
   atributul `hidden`: `display:none` nu are stare intermediară, deci nicio
   tranziție nu poate porni din el. Starea închisă rămâne inaccesibilă la
   tastatură și la screen reader prin `visibility:hidden`, care face parte din
   același tipar.

   `focus()` se dă după DOUĂ `requestAnimationFrame`, nu sincron și nici după
   unul singur. Motivul e măsurat, nu presupus: cu un singur rAF focusul rămânea
   pe buton la toate cele 6 lățimi (`activeElement=pw-staff-btn`). Callback-ul
   de rAF rulează ÎNAINTE de recalcularea stilului din cadrul respectiv, deci
   `visibility` era încă `hidden` și `focus()` pe un element invizibil e ignorat
   în tăcere. Al doilea rAF rulează după ce stilul cadrului anterior s-a aplicat.
   Poarta `task17-password-toggle-check.mjs`, punctul E, prinde regresia asta. */
(function () {
  if (typeof document === 'undefined') return;
  var btn = document.getElementById('pw-staff-btn');
  var block = document.getElementById('pw-staff-block');
  if (!btn || !block) return;
  btn.addEventListener('click', function () {
    var open = !block.classList.contains('is-open');
    block.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open) return;
    var input = block.querySelector('input[type="password"]');
    if (!input) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { input.focus(); });
    });
  });
})();
